export enum SwitchFloorErrors {
  EXIT_DENIED = "EXIT_DENIED",
  FLOOR_CAPACITY_EXCEEDED = "FLOOR_CAPACITY_EXCEEDED",
  MISSING_EVENT_ID = "MISSING_EVENT_ID",
  MISSING_FLOOR_ID = "MISSING_FLOOR_ID",
  SEAT_NOT_FOUND = "SEAT_NOT_FOUND",
  USER_ON_FLOOR = "USER_ON_FLOOR",
}
